import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

interface FunctionAppVersionStatusResponse {
  data: {
    functionAppVersion: string | null;
    applicationVersion: string | null;
    isMismatch: boolean;
  };
  isActionSuccess: boolean;
}

/**
 * Shared Function App version check for the campaign section (US 66801).
 * Never throws: a failed call is logged and treated as "no mismatch" so campaign pages keep working.
 */
@Injectable({ providedIn: 'root' })
export class FunctionAppVersionCheckService {
  private readonly api = 'api/v1/platform/function-app-version-status';
  private readonly isMismatchSubject = new BehaviorSubject<boolean>(false);
  private readonly isCheckingSubject = new BehaviorSubject<boolean>(false);

  readonly isMismatch$ = this.isMismatchSubject.asObservable();
  readonly isChecking$ = this.isCheckingSubject.asObservable();

  constructor(private http: HttpClient) {}

  check(): void {
    if (this.isCheckingSubject.value) {
      return;
    }
    this.isCheckingSubject.next(true);
    this.http.get<FunctionAppVersionStatusResponse>(this.api).subscribe({
      next: (res) => {
        this.isMismatchSubject.next(res?.data?.isMismatch === true);
        this.isCheckingSubject.next(false);
      },
      error: (err) => {
        console.error('Function App version check failed', err);
        this.isMismatchSubject.next(false);
        this.isCheckingSubject.next(false);
      },
    });
  }

  reset(): void {
    this.isMismatchSubject.next(false);
    this.isCheckingSubject.next(false);
  }
}
